"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionCircleIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var QuestionCircleIcon16Light_1 = require("./QuestionCircleIcon16Light");
var QuestionCircleIcon16Regular_1 = require("./QuestionCircleIcon16Regular");
var QuestionCircleIcon16Solid_1 = require("./QuestionCircleIcon16Solid");
var QuestionCircleIcon20Light_1 = require("./QuestionCircleIcon20Light");
var QuestionCircleIcon20Regular_1 = require("./QuestionCircleIcon20Regular");
var QuestionCircleIcon20Solid_1 = require("./QuestionCircleIcon20Solid");
var QuestionCircleIcon24Regular_1 = require("./QuestionCircleIcon24Regular");
var QuestionCircleIcon24Solid_1 = require("./QuestionCircleIcon24Solid");
var QuestionCircleIcon32Regular_1 = require("./QuestionCircleIcon32Regular");
var QuestionCircleIcon64Regular_1 = require("./QuestionCircleIcon64Regular");
var sizes = {
    16: {
        light: QuestionCircleIcon16Light_1.QuestionCircleIcon16Light,
        regular: QuestionCircleIcon16Regular_1.QuestionCircleIcon16Regular,
        solid: QuestionCircleIcon16Solid_1.QuestionCircleIcon16Solid,
    },
    20: {
        light: QuestionCircleIcon20Light_1.QuestionCircleIcon20Light,
        regular: QuestionCircleIcon20Regular_1.QuestionCircleIcon20Regular,
        solid: QuestionCircleIcon20Solid_1.QuestionCircleIcon20Solid,
    },
    24: {
        regular: QuestionCircleIcon24Regular_1.QuestionCircleIcon24Regular,
        solid: QuestionCircleIcon24Solid_1.QuestionCircleIcon24Solid,
    },
    32: {
        regular: QuestionCircleIcon32Regular_1.QuestionCircleIcon32Regular,
    },
    64: {
        regular: QuestionCircleIcon64Regular_1.QuestionCircleIcon64Regular,
    },
};
exports.QuestionCircleIcon = forwardRef_1.forwardRef('QuestionCircleIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
